import styles from './YesNo.module.css';
import React from 'react';

function YesNo({question, handler, group, value}) {
 
    return (
        <div className={styles.container} >
            <span className={styles.question}>{question}</span>
           
           {
            <>
            <label className={styles.inputLabel}>Yes<input type="radio" name={group}  className={styles.input} onChange={() => handler(true)} checked={value} />
            </label>
            
            <label className={styles.inputLabel}>No<input type="radio" name={group}  className={styles.input} onChange={() => handler(false)} checked={!value} />
            </label>
            
            </>
           } 
        </div>
    )
}

export default YesNo;
